import httpClient from "../utilis/jwtRequest";

const PROFESSIONS_URL = "/Professions/";

function getAllProfessions() {
  return httpClient.get(PROFESSIONS_URL);
}

export const professionsService = {
  getAllProfessions,
};

